import React from 'react';

const StarIcon = ({ filled = false, hovered = false, width = '100%', height = '100%' }) => (
  <svg width={width} height={height} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M24 4l5.5 11.1 12.3 1.8-8.9 8.6 2.1 12.2L24 31.9l-11 5.8 2.1-12.2L6.2 16.9l12.3-1.8z"
      fill={filled || hovered ? '#FFCE50' : '#E2E2E2'}
      stroke={filled || hovered ? '#e6b800' : '#bdbdbd'}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

export default StarIcon;
